import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const OT_CATEGORIES = ["None", "OBS", "Daily Shifting"];

export const otCategoryPayload = (r) => {
  const isObs = r.category === "OBS";
  return {
    category: r.category && r.category !== "None" ? r.category : "",
    direct_call: isObs ? r.direct_call || "" : "",
    account_name: isObs ? r.account_name || "" : "",
    contact_person: isObs ? r.contact_person || "" : "",
  };
};

export const OtCategoryFields = ({ row, onChange, testPrefix }) => (
  <div className="space-y-2 min-w-[190px]">
    <Select value={row.category || "None"} onValueChange={(v) => onChange({ category: v })}>
      <SelectTrigger data-testid={`${testPrefix}-category`}><SelectValue placeholder="Category" /></SelectTrigger>
      <SelectContent>
        {OT_CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
      </SelectContent>
    </Select>
    {row.category === "OBS" && (
      <>
        <Select value={row.direct_call || ""} onValueChange={(v) => onChange({ direct_call: v })}>
          <SelectTrigger data-testid={`${testPrefix}-direct-call`}><SelectValue placeholder="Direct call?" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="Yes">Direct call: Yes</SelectItem>
            <SelectItem value="No">Direct call: No</SelectItem>
          </SelectContent>
        </Select>
        <Input value={row.account_name || ""} onChange={(e) => onChange({ account_name: e.target.value })} placeholder="Account / Company name" data-testid={`${testPrefix}-account`} />
        <Input value={row.contact_person || ""} onChange={(e) => onChange({ contact_person: e.target.value })} placeholder="Contact person" data-testid={`${testPrefix}-contact`} />
      </>
    )}
  </div>
);

export const OtCategoryDisplay = ({ row }) => {
  if (!row.category) return <span className="text-muted-foreground">—</span>;
  return (
    <div className="space-y-0.5">
      <p className="font-medium">{row.category}</p>
      {row.category === "OBS" && (
        <p className="text-xs text-muted-foreground">
          Direct call: {row.direct_call || "—"} · {row.account_name || "—"} · {row.contact_person || "—"}
        </p>
      )}
    </div>
  );
};
